import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { OperationService } from '../../../services/operations/operation/operation.service';
import { OpenEndedValidationRow } from '../vis.models';
import { GridComponent, GridDataResult } from '@progress/kendo-angular-grid';
import { process, State } from '@progress/kendo-data-query';
import { DailyLogOperationInstance } from '../../../models/projects/operation.models';
import { DailyLogValidationService } from '../../../services/daily-log/daily-log-validation/daily-log-validation.service';
import { OperationDetailsEditPage } from '../../operations/operation-details-edit/operation-details-edit';
import { columns } from './open-ended.config';
import { DateService } from '../../../services/date/date.service';
import { AppConfig } from '../../../app/app.config';

@IonicPage()
@Component({
  selector: 'page-open-ended',
  templateUrl: 'open-ended.html',
})
export class OpenEndedValidationPage {
  @ViewChild('openEndedGrid') grid?: GridComponent;

  config = AppConfig.settings;
  isWeb: boolean;
  rows: OpenEndedValidationRow[] = [];
  instances: DailyLogOperationInstance[] = [];
  gridData: GridDataResult;
  columns = columns;
  loaded: boolean;

  state: State = {
    take: 500,
    skip: 0,
    filter: {
      logic: 'and',
      filters: []
    },
    sort: [
      {
        field: 'operationName',
        dir: 'asc'
      },
    ],
  };


  constructor(
    public navParams: NavParams,
    public platform: Platform,
    public operationService: OperationService,
    public dailyLogValidatorService: DailyLogValidationService,
    public navCtrl: NavController,
    private dateService: DateService,
  ) {

  }

  async reloadInstances() {
    const ids = this.instances.map(p => p.id);
    this.instances = await this.operationService.getProjectSpecificOperationInstances(ids);

    // todo - remove
    // for (let i = 0; i < this.instances.length; i++) {
    //   this.instances[i] = await this.operationService.removeSystemOffsetsFromInstanceTimes(this.instances[i]);
    // }
  }

  async ionViewDidEnter() {
    this.loaded = false;
    if (!!this.instances) {
      await this.reloadInstances();
    }

    await this.loadData();
    this.loaded = true;
  }

  async ionViewDidLoad() {
    this.isWeb = this.platform.is('core');
    this.instances = this.navParams.get('instances');
  }

  async loadData() {
    this.rows = [];

    const openEndedInstances = this.dailyLogValidatorService.openEndedOperationCount(this.instances);

    for (let i = 0; i < openEndedInstances.length; i++) {
      const newRow = new OpenEndedValidationRow();
      newRow.instanceId = openEndedInstances[i].id;
      newRow.operationClassification = openEndedInstances[i].projectSpecificOperation.operationSummary.classificationName;
      newRow.operationName = openEndedInstances[i].projectSpecificOperation.name
        ? openEndedInstances[i].projectSpecificOperation.name
        : openEndedInstances[i].projectSpecificOperation.operationSummary.name;
      newRow.startTimeShow = await this.dateService.setTimeStringFromDateTime(openEndedInstances[i].startTime.dateTime);
      this.rows.push(newRow);
    }

    this.gridData = process(this.rows, this.state);

  }

  async edit(id: number) {
    const instance = await this.operationService.getProjectSpecificOperationInstance(id);
    this.navCtrl.push(OperationDetailsEditPage, {instance: instance}, {animation: 'ios-transition'});
  }
}



// WEBPACK FOOTER //
// ./src/pages/validation/open-ended/open-ended.ts